import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Avatar, Card, CardContent, Link } from '@mui/material';
import { setLoadingState } from '../../actions/actions';
import { CommonModal } from '../../components';
import { setPrimaryEnrollment, deleteEnrollment } from '../../common/services/Services';
import '../../common/theme/ProfileTheme.scss';
import './MyUserNamesComponent.scss';
import constants from '../../constants';

const MyUserNamesComponent = ({userNames, refreshToken, setNavItem, openGlobalBanner}) => {
  const dispatch = useDispatch();
  const avatarIcon = require('../../img/avatar-icon.png');
  const primaryAvatarIcon = require('../../img/avatar-icon-white.png');
  const [defaultUser, setDefaultUser] = useState(null);
  const [removalMode, setRemovalMode] = useState(false);
  const [selectedUserDescription] = useState();
  const [selectedGUID, setSelectedGUID] = useState();
  const [selectedUserId, setSelectedUserId] = useState();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const defaultUserObj = userNames.find(user => user.is_default === true);

    if (defaultUserObj) {
      setDefaultUser(defaultUserObj.guid);
    } else {
      setDefaultUser(userNames[0].guid);
    }
  }, [userNames]);

  function toggleModal() {
    setShowModal(prevState => !prevState);
  }

  const setUserInfo = (guid, userId) => {
    setSelectedGUID(guid);
    setSelectedUserId(userId);
  }

  const setPrimaryUser = (guid, newUserId) => async () =>  {
    dispatch(setLoadingState(true));
     const { token } = await refreshToken();
    await setUserInfo(guid, newUserId);
    try {
      const setPrimaryResp = (guid !== defaultUser || userNames.length === 1) ? await setPrimaryEnrollment(defaultUser, guid, token) : null;
      setNavItem('MyUserNames', setPrimaryResp, guid, undefined, 'Your primary username has been updated. Please make sure it\'s the one you want.');
    } catch (error) {
      openGlobalBanner(error);
      dispatch(setLoadingState(false));
    }

  };

  const confirmUserRemoval = (guid, userId) => async () => {
    await setUserInfo(guid, userId);
    toggleModal();
  };

  const handleRemoveClick = () => {
      setRemovalMode(!removalMode);
  };

  const removeUser = async () => {
    dispatch(setLoadingState(true));
     const { token } = await refreshToken();
    try {
      const deleteResp = await deleteEnrollment(selectedGUID, token);
      setNavItem('MyUserNames', deleteResp, selectedGUID, defaultUser, 'The username has been removed. To see it again, you can always add it back to your account.');
    } catch (error) {
      openGlobalBanner(error);
      dispatch(setLoadingState(false));
    }

 }

  return (
    <Card className='profile-card'>
      <CardContent className='profile-content'>
        <Box className='profile-title'>My usernames</Box>
        <Box className='profile-text'>
          These are all the usernames connected to your account (you may remember them from your Welcome email). Please review the list and make sure they're all here. Your primary username is the one you see first when logging into your account.        
        </Box>
        <hr className='user-name-divider' />
        { userNames.sort((a, b) => (a.is_default === b.is_default ? new Date(a.createdOn) - new Date(b.createdOn) : a.is_default ? -1 : 1)).map((enrollment, index) => (
        <Box key={index} className='profile-name avatar-list-item username-list'>
          { enrollment.is_default && (
          <>
            <Box className='primary-sub-title'>Primary username</Box>
            <Box className='flex-box'>
              <Avatar src={primaryAvatarIcon} className='primary-user-avatar'></Avatar>
              <Box className='user-name-container'>
                <Box className='user-name'>{enrollment.prismId}</Box>
              </Box>
            </Box>
            { userNames.length > 1 && (
              <Box className='secondary-sub-title'>Secondary usernames</Box>
            )}
          </>
          )}
          { !enrollment.is_default && userNames.length > 0 && (
          <>
            <Box className='flex-box'>
              <Avatar src={avatarIcon} className='user-avatar'></Avatar>
                <Box className='user-name-container'>
                  <Box className='user-name'>{enrollment.prismId}</Box>
                </Box>
                <Box className={`${removalMode ? 'remove-box-text' : 'action-box-text'}`}>
                <Link
                    className={`${removalMode ? 'user-name-remove-link' : 'user-name-action-link '}`}
                    onClick={removalMode ? confirmUserRemoval(enrollment.guid, enrollment.prismId) : setPrimaryUser(enrollment.guid, enrollment.prismId)}>
                    {removalMode ? 'Remove' : 'Set as primary'}
                </Link>
              </Box>
            </Box>
          </>
          )}
          </Box>
        ))}
        { userNames.length > 1 && (
        <Box className='remove-text'>
          Need to take one off the list?{' '}
          <Link className="remove-link" onClick={handleRemoveClick}>
            {removalMode ? 'Cancel' : 'Remove a username'}
          </Link>
        </Box> 
        )}  
        <Box className='add-more-text'>
          Have another username?{' '}
          <Link href='/add-user' className='add-more-link'>
            Add more
          </Link>
        </Box>      
        {showModal &&  <CommonModal type={constants.remove} toggleModal={toggleModal} action={removeUser} selectedUserId={selectedUserDescription ? selectedUserDescription + ' ' + selectedUserId : selectedUserId}/> }
      </CardContent>
    </Card>
  );
};

export default MyUserNamesComponent;